export default __webpack_public_path__ + "static/media/slap_cat.bc18a274.jpg";